Namespace 'Customer'

class Customer.TicketCreatePatagoniaCrmCaseAction extends Backbone.Model

  identifier = 'patagonia'

  initialize: ({ticket}) ->
    @integration = ticket.get('integrations').get(identifier)
    @listenTo(@integration, 'ticket:export:success', @_onSuccess)
    @listenTo(@integration, 'ticket:export:error', @_onError)

  export: =>
    Backbone.trigger('validateCrmData',
      mandatoryFields: @integration.mandatoryFields(),
      ticketId: this.integration.ticket.id,
      onFinish: @_onValidationFinish)

  canCreateExternalTicket: =>
    @integration.canCreateExternalTicket()

  canUpdate: =>
    @integration.canUpdate()

  isLinkedToCrm: =>
    @integration.isLinkedToCrm()

  _onSuccess: (response) =>
    return @_onError(response) unless response.success
    @trigger('ticket:export:patagonia:success', response.message)

  _onError: ({message} = {}) =>
    @trigger('ticket:export:patagonia:error', message)

  _onValidationFinish: ({success, profile_id, message}) =>
    message ||= I18n.t(
      'customer.dashboard.conversations.details.integrations.patagonia_crm_case_mandatory_fields_error'
    )
    if success
      @_export(profile_id)
    else
      @_onError({
        message
      })

  _export: (profile_id) =>
    @integration.exportToCrm(profile_id)
